import { FormControlModule } from './form-control/form-control.module';
import { FormFieldModule } from './form-field/form-field.module';
import { HeaderModule } from './header/header.module';
import { ModalShellModule } from './modal-shell/modal-shell.module';

export const SHARE_MODULES: any[] = [
  FormControlModule,
  FormFieldModule,
  HeaderModule,
  ModalShellModule,
];
